import { SAVE_UPLOAD_INFORMATION_API } from '../constants/AppConstants';

export default async (reportId, requestBody) => {
  try {
    const URL = SAVE_UPLOAD_INFORMATION_API.replace(':reportId', reportId);
    const response = await fetch(URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(requestBody),
      skipAuthHeader: true,
    });
    return { ok: response.ok };
  } catch (error) {
    return { ok: false, json: { errorDescription: 'Internal Server Error' } };
  }
};
